const principles = [
  {
    icon: "ri-focus-3-line",
    title: "编辑逐集把关",
    desc: "每一部番剧都经人工逐集筛选，看点与集数真实可信，拒绝水剧硬推。",
  },
  {
    icon: "ri-heart-3-line",
    title: "治愈而不堆砌",
    desc: "用真实口碑和情感类型为番剧分门别类，让选择更贴合你当下的心情。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新片单",
    desc: "随新番季与用户反馈持续扩充，也会整理冷门宝藏，总有新惊喜。",
  },
];

const reviews = [
  {
    name: "阿橘",
    tag: "深夜追番党",
    text: "照着片单把摇曳露营△看完了，原来生活可以这么治愈，现在每天都期待晚上那一集。",
  },
  {
    name: "小鹿",
    tag: "学生党",
    text: "分类超清楚，标注了集数和看点，再也不用在评论区翻半天找番了，已经安利给全宿舍。",
  },
  {
    name: "老周",
    tag: "上班族",
    text: "工作累了一天，点开治愈片单，感觉一天的疲惫都被熨平了。小狗看番是真的懂。",
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="text-xs font-medium tracking-widest text-accent-600 uppercase">
            关于小狗看番
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            帮你把好番整理成片单的那只小狗
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            小狗看番诞生于一个朴素的想法：在疲惫的一天结束后，我们只想看一部温暖的番，却常常在浩如烟海的片单里迷路。
            所以我们把治愈、日常、温馨、萌系的好番一部部整理出来，标注看点与集数，做成分门别类的片单合集。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们希望每一份片单，都能成为你忙碌生活里的一盏小夜灯。放慢脚步，和小狗一起，选一部番，好好治愈一下。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {principles.map((p) => (
              <div key={p.title} className="rounded-lg bg-background-100 border border-background-200/70 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${p.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-primary-500 p-6 md:p-8">
          <div className="flex items-center gap-2">
            <i className="ri-voiceprint-line text-background-50"></i>
            <h3 className="font-heading text-lg text-background-50">小伙伴的口碑</h3>
          </div>
          <div className="mt-5 space-y-4">
            {reviews.map((r) => (
              <blockquote
                key={r.name}
                className="rounded-lg bg-background-50 p-4"
              >
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{r.name}</p>
                    <p className="text-xs text-primary-600">{r.tag}</p>
                  </div>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">「{r.text}」</p>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}